import React from 'react';
import { Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

// Definindo o tipo para as props do componente BarraSubAbas
interface BoxConteudoProps {
  boxTitulo: string;
  altura?: string;
  children?: React.ReactNode;
  alg?: string;
  fechado?: boolean;
  style?: React.CSSProperties;
  helpText?: string;
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;

  .accordion-item {
    border-radius: 20px;
  }
  .accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
  }
  .accordion-item:first-of-type > .accordion-header .accordion-button {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  .accordion-button {
    font-family: 'Rawline', sans-serif !important;
    font-weight: 400 !important;
  }

  .accordion-button:not(.collapsed) {
    background-color: white;
    box-shadow: none;
  }

  .accordion-button:focus {
    box-shadow: none;
  }
  .help-icon {
    margin-left: 8px;
    cursor: pointer;
    font-size: 1.2rem;
    ${({ theme }) => `
      color: ${theme.colors.azulgov};
    `}
  }
`;

// Ajustando o componente para receber e mapear as SubAbas
const BoxConteudo: React.FC<BoxConteudoProps> = ({
  boxTitulo,
  children,
  fechado,
  style,
  helpText,
}) => {
  return (
    <Box style={style}>
      <Accordion defaultActiveKey={fechado ? undefined : '0'}>
        <Accordion.Item eventKey="0">
          <Accordion.Header style={{ fontFamily: 'Rawline', fontWeight: 800 }}>
            {boxTitulo}
            {helpText && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-${boxTitulo}`}>{helpText}</Tooltip>
                }
              >
                <span className="material-icons help-icon">help</span>
              </OverlayTrigger>
            )}
          </Accordion.Header>
          <Accordion.Body>{children}</Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
};

export default BoxConteudo;
